import { withAIOpsDomainPrefix } from '@atlassian/aiops-common';
import { fetch } from '@atlassian/eoc-fetch';

import type { NoisyReductionMetrics } from '../types';

export const getNoisyReductionMetrics = (
	responderIds?: string[],
): Promise<NoisyReductionMetrics> => {
	return fetch<NoisyReductionMetrics>(withAIOpsDomainPrefix('/v1/alert-insights/snr-filter-view'), {
		exactUrl: true,
		method: 'POST',
		body: {
			responderIds: responderIds ?? [],
		},
	});
};
